

<template>
    <div class="expenseRecord">
      <div class="content-container">
        <div class="titieMian">
          <div class="title-container">费用收入</div>
          <div class="select-container">
            <div class="select-container-box">
              <span>基地&nbsp;&nbsp;</span>
              <el-select v-model="fishBaseId" filterable placeholder="所在基地"  size="small" @change="baseChange">
                <el-option
                  v-for="(item, index) in baseList"
                  :key="index"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </div>
            <div class="select-container-box">
              <span>时间&nbsp;&nbsp;</span>
              <el-date-picker
                size="small"
                v-model="startDate"
                type="date"
                :clearable="false"
                placeholder="开始日期"
                value-format="yyyy-MM-dd"
                @change="changeTime(0)"
                :picker-options="pickerTimeOptions">
              </el-date-picker>
            </div>
            <div class="select-container-box" style="padding:0 5px">
              <span>至</span>
            </div>
            <div class="select-container-box" style="padding:0 1px">
              <el-date-picker
                size="small"
                v-model="endDate"
                type="date"
                :clearable="false"
                placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="changeTime(1)"
                :picker-options="pickerTimeOptions">
              </el-date-picker>
            </div>
            <div class="select-container-box">
              <span>在&nbsp;&nbsp;</span>
              <el-select v-model="type" filterable  size="small"  @change="typeChange">
                <el-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="select-container-box">
              <span>查找&nbsp;&nbsp;</span>
              <el-input
                placeholder="请输入关键字"
                v-model="keyWord"
                :maxlength="num"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                prefix-icon="el-icon-search"
                size="small"
                class="search-input"
                clearable>
              </el-input>
            </div>
            <audit-status :audit-status.sync="auditStatus" />
            <div class="select-container-box">
              <el-button size="small"  type="info" plain @click="search(1)" class="query">查询</el-button>
              <el-button size="small"  type="info" plain @click="add" class="add" v-if="edit">增加</el-button>
              <!-- <el-button size="small"  type="info" plain @click="batchAuditOrder" class="query" style="width: auto;">批量审核</el-button> -->
              <ExportExcelBtn
                apiUrl="/api/CostManage/Export"
                :queryParamsObj="queryParams"
                fileName="费用收入.xls"
              />
            </div>  
          </div>
        </div>  
        <div class="table-container">
          <el-table
            :data="expenseRecordList.list"
            style="width:100%"
            size="medium"
            @row-dblclick="dataBackFillGoods"
            :summary-method="getSummaries"
            show-summary
            :default-sort = "{prop: 'date', order: 'descending'}">
            <i slot="empty" style="font-style:normal">该时间段暂无数据</i>
            <el-table-column
              prop="date"
              label="日期"
              width="170"
              :formatter="formatter"
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="fishBaseName"
              align="center"
              label="基地"
             >
            </el-table-column>
            <el-table-column
              prop="pondName"
              label="塘口"
              align="center"
              :filters="getpondName"
              :filter-method="filterHandler"
              show-overflow-tooltip
             >
            </el-table-column>
            <el-table-column
              prop="fishBatchNo"
              label="周期"
              :filters="getfishBatchNo"
              :filter-method="filterHandler"
              align="center"
          >
            </el-table-column>
             <el-table-column
              prop="costCategoryName"
              label="费用类目"
              :filters="getcostCategoryName"
              :filter-method="filterHandler"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="costTypeName"
              label="费用名称"
              align="center"
              :filters="getcostTypeName"
              :filter-method="filterHandler"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="amount"
              align="center"
              label="金额(元)">
              <template slot-scope="scope">
                <span>
                  {{scope.row.amount.toFixed(2)}}
                </span>
              </template>
           </el-table-column>
            <el-table-column
              prop="ownerName"
              align="center"
              label="制单人"
             >
            </el-table-column>
            <el-table-column label="操作" align="center" width="170">
              <template slot-scope="scope">
                <!-- <span class="content-edit" v-if="scope.row.auditStatus === 0" @click="handleAuditStatus(scope.row)">审核</span> -->
                <span
                  class="content-edit" style="margin-left: 20px;"
                  @click="handleEdit(scope.$index, scope.row)">{{edit?"编辑":"查看"}}</span>
                <span
                  class="content-del"
                  @click="handleDelete(scope.$index, scope.row)" v-if="edit">删除</span>
                <!-- <span v-if="scope.row.auditStatus !== 0">已审核</span> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
         <page-change :pageInfo="pageInfo"></page-change>
      </div>
    </div>
</template>


<script>
import PageChange from "../../common/PageChange";
import AuditStatus from "@/components/AuditStatus";
import ExportExcelBtn from "../../common/ExportExcelBtn";
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { storage } from "../../../service/storage";
import { MessageBox, Message } from "element-ui";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import { resolveFishBaseKeyFromList, fishBaseIdForQuery } from "@/common/resolveFishBaseSelection.js";
export default {
  name: "FeeIncome",
  mixins: [mixins],
  components: {
    PageChange,
    AuditStatus,
    ExportExcelBtn,
  },
  data() {
    return {
      num: 20,
      fishBaseId: "",
      baseList: [], //基地列表
      type: "pondNo",
      typeList: [
        {
          value: "pondNo",
          label: "塘口"
        },
        {
          value: "fishBatch",
          label: "周期"
        },
        {
          value: "costType",
          label: "费用名称"
        }
      ],
      startDate: "", //开始时间
      endDate: "", //结束时间
      pickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      keyWord: "", //查找
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      },
      auditStatus: '', //审核状态 0-待审核 1-已审核
    };
  },
  computed: {
    ...mapState(modules.expense, ["expenseRecordList"]),
    getpondName() {
      const res = new Map();
      let fiterList = this.expenseRecordList.list
        .map(m => ({
          value: m.pondName,
          text: m.pondName
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    getfishBatchNo() {
      const res = new Map();
      let fiterList = this.expenseRecordList.list
        .map(m => ({
          value: m.fishBatchNo,
          text: m.fishBatchNo
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    getcostCategoryName() {
      const res = new Map();
      let fiterList = this.expenseRecordList.list
        .map(m => ({
          value: m.costCategoryName,
          text: m.costCategoryName
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    getcostTypeName() {
      const res = new Map();
      let fiterList = this.expenseRecordList.list
        .map(m => ({
          value: m.costTypeName,
          text: m.costTypeName
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    queryParams () {
      let obj = {
        pageIndex: this.pageInfo.pageNumber || 1,
        pageSize: this.pageInfo.pageSize,
        Type: 2,
        fishBaseId: fishBaseIdForQuery(this.fishBaseId, this.baseList),
        startDate: this.startDate,
        endDate: this.endDate,
        fishBatch: this.fishBatch,
        pondNo: this.pondNo,
        costType: this.costType,
        AuditStatus: this.auditStatus,
      };
      if (this.type === "") {
        obj.fishBatch = this.keyWord;
        obj.pondNo = this.keyWord;
        obj.costType = this.keyWord;
      } else {
        obj[this.type] = this.keyWord;
      }
      return obj;
    }
  },
  async mounted() {
    this.baseList = await this.getAllBaseList({ forQueryAll: true });
    // sessionstorage记住查找关键字
    this.judgeSession("expenseRecordKeyword");
    this.keyWord = this.word;

    let costType = storage.get("costType");
    if (costType) {
      this.type = costType;
    } else {
      this.type = this.typeList[0].value;
      storage.set("costType", this.typeList[0].value);
    }
    // let oldcostType = this.typeList.find(f => f.key == expenseBase);
    // if (oldcostType) {
    //   this.fishBaseId = oldExpenseBase.value;
    // } else if (this.baseList.length > 0) {
    //   this.fishBaseId = this.baseList[0].key; //默认选中第一个
    // }
    // 记住选中基地;
    this.fishBaseId = resolveFishBaseKeyFromList(
      this.baseList,
      storage.get("base")
    );
    this.search(1); //查询
  },
  //默认时间
  created() {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.startDate = startTime;
    } else {
      const startDate = new Date();
      startDate.setDate(1);
      this.startDate = this.$timeformatDay(startDate);
    }
    if (endTime) {
      this.endDate = endTime;
    } else {
      this.endDate = this.$timeformatDay(new Date());
    }
  },
  methods: {
    ...mapActions(modules.expense, [
      "getExpenseRecordData", //查询数据
      "delExpenseRecord" //删除
    ]),
    ...mapActions(modules.base, ["getAllBaseList"]), //基地
    ...mapActions(modules.auditOrder, ["auditCostOrder", "auditCostOrderByMouth"]), // 审核
    // 筛选过滤
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    //记住基地
    baseChange(e) {
      storage.set("base", e);
    },
    typeChange(e) {
      storage.set("costType", e);
    },
    //存储选中时间
    changeTime(type) {
      if (type == 0) {
        storage.set("start", this.startDate);
      } else {
        storage.set("end", this.endDate);
      }
    },
    //双击进入编辑页面
    dataBackFillGoods(row, event) {
      // if(row.auditStatus !== 0) return
      this.$router.push({
        name: "addFeeIncome",
        query: {
          id: row.orderId,
        }
      });
    },
    //合计显示格式
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1 || index === 3) {
          sums[index] = "--";
          return;
        }
        if (index === 2) {
          sums[index] = "";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2) + " ";
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
    // 格式化指定列时间
    formatter(row) {
      if (!row.date) {
        return false;
      }
      return this.$timeformatDay(row.date);
    },

    //查询数据
    search(pageNum) {
      // 设置sessionStorage
      sessionStorage.setItem("expenseRecordKeyword", this.keyWord);
      this.pageInfo.pageNumber = pageNum || 1;

      this.getExpenseRecordData(this.queryParams)
        .then(rsp => {
          if (rsp.status === 200) {
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // Message.error(err.response.data);
          console.dir(err);
        });
    },
    add() {
      //添加
      this.$router.push({
        name: "addFeeIncome",
        query: {
        }
      });
    },
    handleEdit(index, row) {
      //编辑
      this.$router.push({
        name: "addFeeIncome",
        query: { id: row.orderId }
      });
    },
    handleDelete(index, row) {
      //删除
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.delExpenseRecord(row.id);
          this.search(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(err.response.data);
        });
    },
    // 审核
    async handleAuditStatus(row){
      const confirmRes = await this.$confirm('确认审核通过该单据?').catch( err => err )
      if(confirmRes !== 'confirm') return 
      await this.auditCostOrder({
        id: row.orderId,
        auditStatus: 1
      }).catch( err => {
        this.$Alert.info({
          content: err.response.data,
          duration: 5000,
          status: "error"
        });
      })
      this.search()
    },
    // 批量审核
    async batchAuditOrder(){
      const confirmRes = await this.$confirm('', '批量操作', {
        confirmButtonText: '批量审核',
        cancelButtonText: '批量驳回',
        center: true,
        distinguishCancelAndClose: true,
      }).catch( err => err )
      if(confirmRes === 'close') return
      const auditStatus = confirmRes === 'confirm'? 1 : 0;
      const params = {
        auditStatus, // 审核状态 0-待审核 1-已审核 2-审核不通过
        costType: this.costType, // 费用类型
        endDate: this.endDate, // 结束时间
        fishBaseId: fishBaseIdForQuery(this.fishBaseId, this.baseList), // 基地Id
        fishBatch: this.fishBatch, // 周期
        pondNo: this.pondNo, // 塘口编号
        startDate: this.startDate, // 开始时间
        type: 2, // 费用类型 1-支出 2-收入
        pageIndex: 1, // 当前页数(从1开始)
        pageSize: 10000, // 分页条数
      }
      if (this.type === "") {
        params.fishBatch = this.keyWord;
        params.pondNo = this.keyWord;
        params.costType = this.keyWord;
      } else {
        params[this.type] = this.keyWord;
      }
      await this.auditCostOrderByMouth(params).catch( err => {
        this.$Alert.info({
          content: err.response.data,
          duration: 5000,
          status: "error"
        });
      })
      this.search()
    }
  }
};
</script>
<style lang="stylus">
    
</style>
